module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-img-04-2c7eefaa385ce9d0812d52975c1bbd9f.jpg";